import { render } from "./Storage_delete_button.vue?vue&type=template&id=0dcfe5cc&scoped=true"
import script from "./Storage_delete_button.vue?vue&type=script&lang=js"
export * from "./Storage_delete_button.vue?vue&type=script&lang=js"

import "./Storage_delete_button.vue?vue&type=style&index=0&id=0dcfe5cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcfe5cc"]])

export default __exports__